import React, { useState } from "react"
import { MenuButtonWrapper } from "./style"
import ButtonElement from "./ButtonElement"
import MobileMenu from "../MobileMenu"

const MenuButton = () => {
  const [menuActive, setMenuActive] = useState<boolean>(false)
  const [display, setDisplay] = useState<boolean>(false)
  const toggleMenu = () => {
    if (display === false) {
      setDisplay(true)
      setMenuActive(true)
    } else {
      setTimeout(() => setDisplay(false), 400)
      setMenuActive(false)
    }
  }
  return (
    <>
      <MenuButtonWrapper onClick={toggleMenu} menuActive={menuActive}>
        <ButtonElement top={0} />
        <ButtonElement top={15} />
        <ButtonElement top={30} />
      </MenuButtonWrapper>
      <MobileMenu isActive={menuActive} display={display} />
    </>
  )
}

export default MenuButton
